/* Vue */
import Vue from 'vue'
import router from './router'
import store from './store'
/* App sass */
import './assets/style/app.scss'
/* App component */
import App from './App'
/* Auth plugin */
import Auth from './auth'
/* Notification plugin */
import Notification from './notification'
import LzString from './lz-string'
import Guid from './guid'
import * as Sentry from '@sentry/vue'
import { enrichSentryEvent, setSentryUserContext } from './services/sentryUserContext'
// Vue.use(VueResource)
Vue.config.productionTip = false

Vue.use(Auth)

Vue.use(Notification)
Vue.use(LzString)
Vue.use(Guid)

Vue.prototype.$screen = Vue.observable({
  width: window.innerWidth,
  height: window.innerHeight
})
// bulma grid' breakpoints
Vue.prototype.$screen.breakpoints = {
  mobile: 768,
  tablet: 769,
  desktop: 1024,
  widescreen: 1216,
  fullHD: 1408
}

window.addEventListener('resize', () => {
  Vue.prototype.$screen.width = window.innerWidth
  Vue.prototype.$screen.height = window.innerHeight
})

const enableInDevelopment = process.env.VUE_APP_SENTRY_ENABLE_IN_DEV === 'true'
console.log('NODE_ENV:', process.env.NODE_ENV)
if (process.env.NODE_ENV === 'production' || enableInDevelopment) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    sendDefaultPii: true,
    environment: process.env.NODE_ENV || 'development',
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true, // Default: Masks all text with **** for privacy
        blockAllMedia: true // Default: Blocks images/videos
      })
    ],
    replaysSessionSampleRate: 0.05, // 5% of all sessions
    replaysOnErrorSampleRate: 1.0,  // 100% of sessions with an error
    beforeSend: enrichSentryEvent
  })

  setSentryUserContext()
}

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
